import { useEffect, useState } from "react";
import orderBy from "lodash/orderBy";
import { useInView } from "react-intersection-observer";
import { useSelector } from "react-redux";

import { getDispensaryPromotions } from "api/requests/getDispensaryPromotions";
import { DispensaryPromotion } from "custom-types/Promotions";
import { getCurrentDispensary } from "redux/selectors/dispensary";

const useDispensaryPromotions = ({
  loadOnScroll,
}: {
  loadOnScroll?: boolean;
}) => {
  const { id } = useSelector(getCurrentDispensary);

  const [promotions, setPromotions] = useState<DispensaryPromotion[]>([]);

  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (id && (inView || !loadOnScroll)) {
      getDispensaryPromotions(id).then((response) =>
        setPromotions(orderBy(response, ["orderNumber"], "asc"))
      );
    }
  }, [id, inView]);

  return {
    hasPromotions: promotions.length > 0,
    promotions,
    ref,
  };
};

export default useDispensaryPromotions;
